import * as React from 'react';
import { ActionLink, UIText2 } from '@cian/ui-kit';

import { IconActionArrowUpRight16, IconFunctionalInformationCircle24 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './PromoCategoryPlate.css';
import { trackPromoCategoryPlateButtonClick } from '../../utils/analytics';

interface IPromoCategoryPlateProps {
  onButtonLinkClick: () => void;
  text: string;
  articleUrl?: string | null;
  hasModal: boolean;
}

export const PromoCategoryPlate: React.FC<IPromoCategoryPlateProps> = ({
  onButtonLinkClick,
  text,
  articleUrl,
  hasModal,
}) => {
  return (
    <section className={styles['plate']} data-testid="PromoCategoryPlate">
      <span>
        <IconFunctionalInformationCircle24 color="icon-positive-default" />
      </span>
      <div className={styles['content']}>
        <UIText2>{text}</UIText2>
        <div className={styles['link']}>
          {hasModal && (
            <ActionLink fontSize="M" onClick={onButtonLinkClick} color="current_color">
              Посмотреть условия
            </ActionLink>
          )}
          {!hasModal && articleUrl && (
            <a href={articleUrl} target="_blank" rel="noreferrer">
              <ActionLink
                color="current_color"
                fontSize="M"
                afterIcon={<IconActionArrowUpRight16 color="icon-positive-default" />}
                onClick={trackPromoCategoryPlateButtonClick}
              >
                Изучить подробнее
              </ActionLink>
            </a>
          )}
        </div>
      </div>
    </section>
  );
};
